"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCanvasOrientation = void 0;
const react_1 = require("react");
function useCanvasOrientation(canvasWidth, canvasHeight) {
    const [canvasOrientation, setCanvasOrientation] = (0, react_1.useState)('landscape');
    const [canvasAspectRatioConversion, setCanvasAspectRatioConversion] = (0, react_1.useState)(canvasWidth / canvasHeight);
    (0, react_1.useEffect)(() => {
        const newCanvasOrientation = canvasHeight > canvasWidth ? 'portrait' : 'landscape';
        const newCanvasAspectRatioConversion = canvasWidth / canvasHeight;
        if (newCanvasOrientation !== canvasOrientation) {
            setCanvasOrientation(newCanvasOrientation);
            setCanvasAspectRatioConversion(newCanvasAspectRatioConversion);
            document.documentElement.style.setProperty('--aspect-ratio-conversion', newCanvasAspectRatioConversion + '');
        }
        if (newCanvasOrientation === canvasOrientation &&
            canvasAspectRatioConversion !== newCanvasAspectRatioConversion) {
            setCanvasAspectRatioConversion(newCanvasAspectRatioConversion);
            document.documentElement.style.setProperty('--aspect-ratio-conversion', newCanvasAspectRatioConversion + '');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canvasWidth, canvasHeight]);
    return canvasAspectRatioConversion;
}
exports.useCanvasOrientation = useCanvasOrientation;
//# sourceMappingURL=use_canvas_orientation.js.map